import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'

// Date formatting
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, Icon, Table, Input, Checkbox } from 'semantic-ui-react';

// System data
import { optionsBoard } from "./systemdata";
import { optionsChildren } from "./systemdata";

// Actions
import { doContractAction } from "./contractSlice";
import { setContractData } from "./contractSlice";

// Toolbox
import { toGermanCurrency, toPercent } from "../../toolbox";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');




/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractSeasonRoomsPrices = ({ editMode }) => {
  // local Stage
  const [seasonsStart, setSeasonsStart] = useState(0);

  // global Stage
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const seasonsDisplayMax = useSelector((state) => state.contract.maxSeasonsVisible);
  const dataSeasons = Contract.Seasons;
  
  // Edit mode?
  const readOnly = editMode ? false : true;

  // check if rooms defined
  if (typeof Contract?.Rooms === 'undefined' || !Contract?.Rooms.length) {
    return (
      <p>Keine Zimmer definiert</p>
    )
  }

  // Filter visible seasons
  const moreSeasons = Object.keys(dataSeasons).length > seasonsDisplayMax ? true : false;
  let i=-1;
  let seasonsToDisplay = [];
  for (const seasonKey in dataSeasons) {
    i++;
    if (Object.prototype.hasOwnProperty.call(dataSeasons, seasonKey)) {
      if (i >= seasonsStart && i < (seasonsStart + seasonsDisplayMax)) {
        seasonsToDisplay.push(seasonKey);
      }
    }
  }

  //
  const nextSeasonClick = () => {
    if ((seasonsStart + seasonsDisplayMax) < (Object.keys(dataSeasons).length)) {
      setSeasonsStart(seasonsStart + 1)
    }
  };

  //
  const prevSeasonClick = () => {
    if (seasonsStart > 0) {
      setSeasonsStart(seasonsStart - 1)
    }
  };

  // only float numbers allowed (Prices, Reductions)
  const handleKeyPressFloat = (e) => {
    if (!/^\d{0,4}(\.\d{0,2})?$/.test(e.key)) {
      e.preventDefault();
    }
  };

  // only float numbers allowed (Prices, Reductions)
  const handleFormatFloat = (e, callbackFn, param) => {
    let inputValue = e.target.value.replace(",", ".");
    const number = parseFloat(inputValue);
    if (!isNaN(number) && callbackFn) {
      if (typeof param !== 'undefined' && param === 'PERCENT') {
        callbackFn(number.toFixed(0));
      } else {
        callbackFn(number.toFixed(2));
      }
    }
  }

  // only numbers allowed (Allotment, Ages)
  const handleKeyPressNumber = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };








  const roomRows = Contract.Rooms.map((room, roomKey) => {

    const hasChildReductions = room.Reductions.length ? true : false;
    const hasAdultReductions = room.AdultReduction ? true : false;
    const roomCodeRowSpan = room.Reductions.length + (hasAdultReductions ? 2 : 1)

    // calculate average room price
    let avgRoomPrice = 0;
    let countRoomPrices = 0;
    for (const key in room.Prices) {
      if (Object.prototype.hasOwnProperty.call(room.Prices, key)) {
        avgRoomPrice += parseFloat(room.Prices[key]?.Amount);
        countRoomPrices++;
      }
    }
    avgRoomPrice = (avgRoomPrice / countRoomPrices).toFixed(2);

    //
    const childRows = room.Reductions.map((reduction, reductionIndex) => {

      //
      const optionsChildrenSelect = optionsChildren.map(child => {
        if (reduction.ChildNumber === child.value) {
          return <option key={child.key} value={child.value}>{child.text}</option>;
        }          
        return <option key={child.key} value={child.value}>{child.text}</option>;
      });

      //
      return (
        <Table.Row key={reductionIndex}>
          <Table.Cell className="child" textAlign='center'>
            {readOnly ? (
              <span>{reduction.ChildNumber === 5 ? 'alle Kinder' : reduction.ChildNumber+'. Kind'}, {reduction.ChildAgeFrom} - {reduction.ChildAgeTo} Jahre</span>
            ) : (
              <>
              <select value={reduction.ChildNumber} className="select_small" onChange={(e) => dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, target: 'Prices.Reduction.ChildNumber', value: e.target.value}))}>
                <option>bitte wählen</option>
                {optionsChildrenSelect}
              </select>
              <Input className="small" maxLength={2} style={{width: "30px", textAlign: "right"}} value={reduction.ChildAgeFrom} onKeyPress={handleKeyPressNumber} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, target: 'Prices.Reduction.ChildAgeFrom', value: data.value}))} />
              <span>&nbsp;-&nbsp;</span>
              <Input className="small" maxLength={2} style={{width: "30px", textAlign: "right"}} value={reduction.ChildAgeTo} onKeyPress={handleKeyPressNumber} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, target: 'Prices.Reduction.ChildAgeTo', value: data.value}))} />  
              </>
            )}
          </Table.Cell>
          <Table.Cell className="child">
            {readOnly ? (
              <>
              {reduction.AllTheSame ? (<Icon circular name='check' />) : (<></>)}
              </>
            ) : (
              <Checkbox toggle checked={reduction.AllTheSame ? true : false} onClick={() => { if (!readOnly) { dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, target: 'Prices.Reduction.AllTheSame', value: !reduction.AllTheSame}))}}} />
            )}
          </Table.Cell>

          {reduction.AllTheSame ? (
            <>
              {readOnly ? (
                <>
                <Table.Cell colspan={seasonsToDisplay.length} textAlign='center' className='child odd'>
                  {reduction.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? <Icon link name = "euro" className = "toggle active" /> : <></>}
                  {reduction.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? toGermanCurrency(reduction.Reductions[seasonsToDisplay[0]]?.Value) : toPercent(reduction.Reductions[seasonsToDisplay[0]]?.Value)}
                  {reduction.Reductions[seasonsToDisplay[0]]?.Type === 'PERCENT' ? <Icon link name = "percent" className = "toggle active" /> : <></>}
                </Table.Cell>
                </>
              ) : (
                <>
                <Table.Cell colspan={seasonsToDisplay.length} textAlign='center' className='child odd'>
                  <Icon 
                    link 
                    name = "euro" 
                    className = {reduction.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? "toggle active" : "toggle"} 
                    onClick = {() => {
                      if (reduction.Reductions[seasonsToDisplay[0]].Type === 'AMOUNT') {
                        dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Type', value: 'PERCENT'}))
                        if (reduction.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonsToDisplay[0]]?.Value).toFixed(0) }))
                        }
                      } else {
                        dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Type', value: 'AMOUNT'}))
                        if (reduction.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonsToDisplay[0]]?.Value).toFixed(2) }))
                        }
                      }
                    }}
                  />
                  <Input 
                    className   = "small" 
                    maxLength   = {7} 
                    style       = {{width: "65px", textAlign: "right"}} 
                    value       = {reduction.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? toGermanCurrency(reduction.Reductions[seasonsToDisplay[0]]?.Value) : toPercent(reduction.Reductions[seasonsToDisplay[0]]?.Value)}
                    onKeyPress  = {handleKeyPressFloat}
                    onBlur      = {(e)=> handleFormatFloat(e, (val)=>dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Value', value: val})), reduction.Reductions[seasonsToDisplay[0]]?.Type)}
                    onChange    = {(e, data) => dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Value', value: data.value}))} 
                  />
                  <Icon 
                    link 
                    name = "percent" 
                    className = {reduction.Reductions[seasonsToDisplay[0]]?.Type === 'PERCENT' ? "toggle active" : "toggle"} 
                    onClick = {(e, data) => {
                      if (reduction.Reductions[seasonsToDisplay[0]].Type === 'AMOUNT') {
                        dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Type', value: 'PERCENT'}))
                        if (reduction.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonsToDisplay[0]]?.Value).toFixed(0) }))
                        }
                      } else {
                        dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Type', value: 'AMOUNT'}))
                        if (reduction.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonsToDisplay[0], target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonsToDisplay[0]]?.Value).toFixed(0) }))
                        }
                      }
                    }}
                  />
                </Table.Cell>
                </>
              )}
            </>
          ) : (
            <>
              {seasonsToDisplay.map((seasonKey, seasonIndex) => (
                <Table.Cell key={seasonKey} textAlign='center' className={seasonIndex % 2 ? 'child even' : 'child odd'}>
                  {readOnly ? (
                    <>
                      {reduction.Reductions[seasonKey]?.Type === 'AMOUNT' ? <Icon link name = "euro" className = "toggle active" /> : <></>}
                      {reduction.Reductions[seasonKey]?.Type === 'AMOUNT' ? toGermanCurrency(reduction.Reductions[seasonKey]?.Value) : toPercent(reduction.Reductions[seasonKey]?.Value)}
                      {reduction.Reductions[seasonKey]?.Type === 'PERCENT' ? <Icon link name = "percent" className = "toggle active" /> : <></>}
                    </>
                  ) : (
                    <>
                    <Icon 
                      link 
                      name = "euro" 
                      className = {reduction.Reductions[seasonKey]?.Type === 'AMOUNT' ? "toggle active" : "toggle"} 
                      onClick = {() => {
                        if (reduction.Reductions[seasonKey].Type === 'AMOUNT') {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Type', value: 'PERCENT'}))
                          if (reduction.Reductions[seasonKey]?.Value) {
                            dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonKey]?.Value).toFixed(0) }))
                          }
                        } else {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Type', value: 'AMOUNT'}))
                          if (reduction.Reductions[seasonKey]?.Value) {
                            dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonKey]?.Value).toFixed(2) }))
                          }
                        }
                      }}
                    />
                    <Input 
                      className   = "small" 
                      maxLength   = {7} 
                      style       = {{width: "65px", textAlign: "right"}} 
                      value       = {reduction.Reductions[seasonKey]?.Type === 'AMOUNT' ? toGermanCurrency(reduction.Reductions[seasonKey]?.Value) : toPercent(reduction.Reductions[seasonKey]?.Value)}
                      onKeyPress  = {handleKeyPressFloat}
                      onBlur      = {(e)=> handleFormatFloat(e, (val)=>dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Value', value: val})), reduction.Reductions[seasonKey]?.Type)}
                      onChange    = {(e, data) => dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Value', value: data.value}))} 
                    />
                    <Icon 
                      link 
                      name = "percent" 
                      className = {reduction.Reductions[seasonKey]?.Type === 'PERCENT' ? "toggle active" : "toggle"} 
                      onClick = {(e, data) => {
                        if (reduction.Reductions[seasonKey].Type === 'AMOUNT') {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Type', value: 'PERCENT'}))
                          if (reduction.Reductions[seasonKey]?.Value) {
                            dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonKey]?.Value).toFixed(0) }))
                          }
                        } else {
                          dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Type', value: 'AMOUNT'}))
                          if (reduction.Reductions[seasonKey]?.Value) {
                            dispatch(setContractData({roomKey: roomKey, reductionKey: reductionIndex, seasonKey: seasonKey, target: 'Prices.Reduction.Value', value: parseFloat(reduction.Reductions[seasonKey]?.Value).toFixed(0) }))
                          }
                        }
                      }}
                    />
                    </>
                  )}
                </Table.Cell>
              ))}
            </>
          )}


          
          {reductionIndex === 0 && (
            <Table.Cell rowSpan={room.Reductions.length} className="child" textAlign="center">
              {!readOnly && (
                <>
                <Button basic icon circular size="tiny" title="Kinderzeile hinzufügen" onClick={()=>dispatch(doContractAction({ roomKey: roomKey, target: 'Prices.addChildRow' }))}><Icon name="add"/></Button>
                <br />
                <Button basic icon circular size="tiny" title="Kinderzeile löschen" onClick={()=>dispatch(doContractAction({ roomKey: roomKey, target: 'Prices.delChildRow' }))}><Icon name="minus"/></Button>
                </>
              )}
            </Table.Cell>
          )}
        </Table.Row>
      )
    });



    return (
      <Table.Body key={room.RoomCode}>
        <Table.Row>
          <Table.Cell className="room" rowSpan={roomCodeRowSpan} textAlign="center">{room.RoomCode}</Table.Cell>
          <Table.Cell className="room" textAlign='center'>
            {readOnly ? 
              <>
              {optionsBoard.map(board => (
                <>
                {room.Board === board.value ? (<>{board.text}</>) : (<></>)}
                </>
              ))}
              </>
              :
              <select value={room.Board} className="select_small" onChange={(e) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Board', value: e.target.value}))}>
                <option>bitte wählen</option>
                {optionsBoard.map(board => (
                  <option key={board.key} value={board.value}>{board.text}</option>
                ))}
              </select>
            }
          </Table.Cell>
          <Table.Cell className="room">{avgRoomPrice}</Table.Cell>
          {seasonsToDisplay.map((seasonKey, seasonIndex) => (
            <Table.Cell key={seasonKey} textAlign={readOnly ? 'center' : 'right'} className={seasonIndex % 2 ? 'room even' : 'room odd'}>
              {readOnly ? 
              <>
                <label>Preis:&nbsp;</label>
                <span>{toGermanCurrency(room.Prices[seasonKey].Amount)}&nbsp;€&nbsp;</span>
                <label>&nbsp;Kont.:&nbsp;</label>
                <span>{room.Allotments[seasonKey].Amount}</span>
              </>
              :
              <>
                <label>Preis&nbsp;</label>
                <Input 
                  className   = "small" 
                  maxLength   = {7} 
                  style       = {{width: "75px", textAlign: "right"}} 
                  value       = {toGermanCurrency(room.Prices[seasonKey].Amount)} 
                  onKeyPress  = {handleKeyPressFloat} 
                  onBlur      = {(e)=> handleFormatFloat(e, (val)=>dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Rooms.Price', value: val})))}
                  onChange    = {(e, data) => { dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Rooms.Price', value: data.value})) }} 
                /><br />
                <label>Kont.&nbsp;</label>
                <Input 
                  type        = "number" 
                  className   = "small" 
                  maxLength   = {2} 
                  style       = {{width: "75px", textAlign: "right"}} 
                  onKeyPress  = {handleKeyPressNumber} 
                  value       = {room.Allotments[seasonKey].Amount} 
                  onChange    = {(e, data) => dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Rooms.Allotment', value: parseInt(data.value)}))} 
                />
              </>
              }

            </Table.Cell>
          ))}
          <Table.Cell className="room" textAlign="center">
            {!readOnly && (
              <>
                {!hasChildReductions && (
                  <Button basic icon circular size="tiny" title="Kinderzeile hinzufügen" onClick={()=>dispatch(doContractAction({ roomKey: roomKey, target: 'Prices.addChildRow' }))}><Icon name="add"/>&nbsp;Kind</Button>
                )}
                {!hasChildReductions && !hasAdultReductions && (<br />)}
                {!hasAdultReductions && (
                  <Button basic icon circular size="tiny" title="Erwachsenenermäßigung hinzufügen" onClick={()=>dispatch(doContractAction({ roomKey: roomKey, target: 'Prices.addAdultRow' }))}><Icon name="add"/>&nbsp;Erw.</Button>
                )}
              </>
            )}
          </Table.Cell>
        </Table.Row>
        
        {childRows}
        
        {hasAdultReductions && (
          <Table.Row>
            <Table.Cell textAlign='center' className="adult">zus. Erwachsene</Table.Cell>
            <Table.Cell className="adult">
              {readOnly ? (
                <>
                {room.AdultReduction.AllTheSame ? (<Icon circular name='check' />) : (<></>)}
                </>
              ) : (
                <Checkbox toggle checked={room.AdultReduction?.AllTheSame ? true : false} onClick={() => { if (!readOnly) { dispatch(setContractData({roomKey: roomKey, target: 'Prices.AdultReduction.AllTheSame', value: !room.AdultReduction?.AllTheSame}))}}} />
              )}
            </Table.Cell>


            {room.AdultReduction?.AllTheSame ? (
            <>
              {readOnly ? (
                <Table.Cell colspan={seasonsToDisplay.length} textAlign='center' className='child odd'>
                  {room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? <Icon link name = "euro" className = "toggle active" /> : <></>}
                  {room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? toGermanCurrency(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value) : toPercent(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value)}
                  {room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type === 'PERCENT' ? <Icon link name = "percent" className = "toggle active" /> : <></>}
                </Table.Cell>
              ) : (
                <Table.Cell colspan={seasonsToDisplay.length} textAlign='center' className='child odd'>
                  <Icon 
                    link 
                    name = "euro" 
                    className = {room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? "toggle active" : "toggle"} 
                    onClick = {() => {
                      if (room.AdultReduction?.Reductions[seasonsToDisplay[0]].Type === 'AMOUNT') {
                        dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Type', value: 'PERCENT'}))
                        if (room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value).toFixed(0) }))
                        }
                      } else {
                        dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Type', value: 'AMOUNT'}))
                        if (room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value).toFixed(2) }))
                        }
                      }
                    }}
                  />
                  <Input 
                    className   = "small" 
                    maxLength   = {7} 
                    style       = {{width: "65px", textAlign: "right"}} 
                    value       = {room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type === 'AMOUNT' ? toGermanCurrency(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value) : toPercent(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value)}
                    onKeyPress  = {handleKeyPressFloat}
                    onBlur      = {(e)=> handleFormatFloat(e, (val)=>dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Value', value: val})), room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type)}
                    onChange    = {(e, data) => dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Value', value: data.value}))} 
                  />
                  <Icon 
                    link 
                    name = "percent" 
                    className = {room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Type === 'PERCENT' ? "toggle active" : "toggle"} 
                    onClick = {() => {
                      if (room.AdultReduction?.Reductions[seasonsToDisplay[0]].Type === 'AMOUNT') {
                        dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Type', value: 'PERCENT'}))
                        if (room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value).toFixed(0) }))
                        }
                      } else {
                        dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Type', value: 'AMOUNT'}))
                        if (room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value) {
                          dispatch(setContractData({roomKey: roomKey, seasonKey: seasonsToDisplay[0], target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonsToDisplay[0]]?.Value).toFixed(0) }))
                        }
                      }
                    }}
                  />
                </Table.Cell>
              )}
              </>
            ) : (
              <>
              {seasonsToDisplay.map((seasonKey, seasonIndex) => (
                <Table.Cell key={seasonKey} textAlign='center' className={seasonIndex % 2 ? 'adult even' : 'adult odd'}>
                  {readOnly ? (
                      <>
                        {room.AdultReduction.Reductions[seasonKey]?.Type === 'AMOUNT' ? <Icon link name = "euro" className = "toggle active" /> : <></>}
                        {room.AdultReduction.Reductions[seasonKey]?.Type === 'AMOUNT' ? toGermanCurrency(room.AdultReduction.Reductions[seasonKey]?.Value) : toPercent(room.AdultReduction.Reductions[seasonKey]?.Value)}
                        {room.AdultReduction.Reductions[seasonKey]?.Type === 'PERCENT' ? <Icon link name = "percent" className = "toggle active" /> : <></>}
                      </>
                    ) : (
                      <>
                      <Icon 
                        link 
                        name = "euro" 
                        className = {room.AdultReduction?.Reductions[seasonKey]?.Type === 'AMOUNT' ? "toggle active" : "toggle"} 
                        onClick = {() => {
                            if (room.AdultReduction?.Reductions[seasonKey].Type === 'AMOUNT') {
                              dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Type', value: 'PERCENT'}))
                              if (room.AdultReduction?.Reductions[seasonKey]?.Value) {
                                dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonKey]?.Value).toFixed(0) }))
                              }
                            } else {
                              dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Type', value: 'AMOUNT'}))
                              if (room.AdultReduction?.Reductions[seasonKey]?.Value) {
                                dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonKey]?.Value).toFixed(2) }))
                              }
                            }
                        }}
                      />
                      <Input 
                        className   = "small" 
                        maxLength   = {7} 
                        style       = {{width: "65px", textAlign: "right"}} 
                        value       = {room.AdultReduction?.Reductions[seasonKey]?.Type === 'AMOUNT' ? toGermanCurrency(room.AdultReduction?.Reductions[seasonKey]?.Value) : toPercent(room.AdultReduction?.Reductions[seasonKey]?.Value)}
                        onKeyPress  = {handleKeyPressFloat}
                        onBlur      = {(e)=> handleFormatFloat(e, (val)=>dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Value', value: val})), room.AdultReduction?.Reductions[seasonKey]?.Type)}
                        onChange    = {(e, data) => dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Value', value: data.value}))} 
                      />
                      <Icon 
                        link 
                        name = "percent" 
                        className = {room.AdultReduction?.Reductions[seasonKey]?.Type === 'PERCENT' ? "toggle active" : "toggle"} 
                        onClick = {() => {
                            if (room.AdultReduction?.Reductions[seasonKey].Type === 'AMOUNT') {
                              dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Type', value: 'PERCENT'}))
                              if (room.AdultReduction?.Reductions[seasonKey]?.Value) {
                                dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonKey]?.Value).toFixed(0) }))
                              }
                            } else {
                              dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Type', value: 'AMOUNT'}))
                              if (room.AdultReduction?.Reductions[seasonKey]?.Value) {
                                dispatch(setContractData({roomKey: roomKey, seasonKey: seasonKey, target: 'Prices.AdultReduction.Value', value: parseFloat(room.AdultReduction?.Reductions[seasonKey]?.Value).toFixed(0) }))
                              }
                            }
                        }}
                      />
                      </>
                    )}
                </Table.Cell>
              ))}
              </>
            )}
            <Table.Cell className="adult" textAlign="center">
              {!readOnly && (
                <Button basic icon circular size="tiny" title="Erwachsenenermäßigung entfernen" onClick={()=>dispatch(doContractAction({ roomKey: roomKey, target: 'Prices.delAdultRow' }))}><Icon name="minus"/></Button>
              )}
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    )
  });

  


  //
  const headerSeasons = seasonsToDisplay.map((seasonKey, seasonIndex) => {
    const headerSeasonsPeriods = dataSeasons[seasonKey].map((period, index) => {
      if (!period.Start || !period.End) {
        return <></>
      }
      const fdateStart = format(new Date(period.Start), 'dd.MM.')
      const fdateEnd = format(new Date(period.Start), 'dd.MM.')
      return (
        <span key={index}>{fdateStart} - {fdateEnd}<br /></span>
      )
    });

    return (
      <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">
        {headerSeasonsPeriods}
      </Table.HeaderCell>
    )
  });




  

  return (
    <Table celled structured singleLine basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell rowSpan="2" textAlign="center">Zimmer</Table.HeaderCell>
          <Table.HeaderCell rowSpan="2" textAlign="center">Grundverpflegung</Table.HeaderCell>
          <Table.HeaderCell rowSpan="2" textAlign="center" style={{width: "75px"}}>
            {moreSeasons && seasonsStart > 0 && (
              <Icon link name='chevron left' onClick={()=>prevSeasonClick()} />
            )}
          </Table.HeaderCell>
          {seasonsToDisplay.map((seasonKey, seasonIndex) => (
            <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">Saison {seasonKey}</Table.HeaderCell>
          ))}
          <Table.HeaderCell rowSpan="2" textAlign="center" style={{width: "75px"}}>
            {moreSeasons && (seasonsStart + seasonsDisplayMax) < Object.keys(dataSeasons).length && (
              <Icon link name='chevron right' onClick={()=>nextSeasonClick()} />
            )}
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          {headerSeasons}
        </Table.Row>
      </Table.Header>
      {roomRows}
    </Table>
  );
}


export default Max2ContractSeasonRoomsPrices;